/**
 * Module overviews keep a successful list for a minute (the app-wide stale
 * time). Opening the overview after a new check then shows that snapshot
 * until the page is reloaded.
 * These options load the current list every time the overview is opened.
 */
export const overviewListQueryOptions = {
  staleTime: 0,
  refetchOnMount: "always" as const,
};

/** How often an overview refreshes while a check is still running. */
export const OVERVIEW_PENDING_POLL_MS = 5000;

/**
 * Reload the list while a row is still running.
 * Finished and failed rows stay put. Opening the overview already loads the
 * current list, so a manual reload button is not required.
 * React Query v2 accepts a number here, not a callback, so callers pass the
 * cached list and recompute this on each render.
 */
export function overviewPendingRefetchInterval(data: unknown): number | false {
  if (!Array.isArray(data)) {
    return false;
  }
  const stillRunning = data.some((row) => {
    if (!row || typeof row !== "object") {
      return false;
    }
    const status = (row as { status?: unknown }).status;
    if (typeof status !== "string" || status === "") {
      return false;
    }
    return status !== "finished" && status !== "failed";
  });
  return stillRunning ? OVERVIEW_PENDING_POLL_MS : false;
}
